import React, { forwardRef } from 'react';
import styled from 'styled-components';

const ShippingCost = styled.svg`
  fill: none;
  width: 16px;
  height: 16px;
`;

type OwnProps = React.SVGProps<SVGSVGElement>;

const ShippingCostIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <ShippingCost
    {...props}
    ref={ref}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 11L5.33333 11C5.11696 11 4.90643 10.9298 4.73333 10.8L1 7.99999H11M11 11V7.99999M11 11H12.8186C14.1563 11 15.117 9.71209 14.7356 8.42986L14.4425 7.44444C13.9138 5.22222 13.9138 5 12.8563 5H11M11 5V7V7.99999M11 5V7.99999"
      stroke="#666666"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path d="M8 3L5 3" stroke="#666666" strokeWidth="2" strokeLinecap="round" />
    <circle cx="2" cy="3" r="1" fill="#666666" />
    <path
      d="M6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13C5.55228 13 6 12.5523 6 12Z"
      stroke="#666666"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12Z"
      stroke="#666666"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </ShippingCost>
));

export default ShippingCostIcon;
